import { render, staticRenderFns } from "./OpcionesExtras.vue?vue&type=template&id=045d1833&scoped=true"
import script from "./OpcionesExtras.vue?vue&type=script&lang=js"
export * from "./OpcionesExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d1833",
  null
  
)

export default component.exports